import { mapColors } from '@/config/colors'

export const oddEditorStyles = [
  // default styles
  // --- FILL ---
  // FILL INACTIVE
  {
    id: 'gl-draw-polygon-fill-inactive',
    type: 'fill',
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Polygon'],
      ['!=', 'mode', 'static']
    ],
    paint: {
      'fill-color': mapColors.routeColor,
      'fill-outline-color': mapColors.routeColor,
      'fill-opacity': 0.1
    }
  },
  // FILL ACTIVE
  {
    id: 'gl-draw-polygon-fill-active',
    type: 'fill',
    filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
    paint: {
      'fill-color': mapColors.activeColor,
      'fill-outline-color': mapColors.activeColor,
      'fill-opacity': 0.1
    }
  },
  // FILL MIDPOINT
  {
    id: 'gl-draw-polygon-midpoint',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
    paint: {
      'circle-radius': 3,
      'circle-color': mapColors.activeColor,
      'circle-pitch-alignment': 'map'
    }
  },
  // FILL STROKE INACTIVE
  {
    id: 'gl-draw-polygon-stroke-inactive',
    type: 'line',
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Polygon'],
      ['!=', 'mode', 'static']
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': mapColors.routeColor,
      'line-width': 2
    }
  },
  // FILL STROKE ACTIVE
  {
    id: 'gl-draw-polygon-stroke-active',
    type: 'line',
    filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': mapColors.activeColor,
      // 'line-dasharray': [0.2, 2],
      'line-width': 2
    }
  },
  // --- LINE ---
  // LINE INACTIVE
  {
    id: 'gl-draw-line-inactive',
    type: 'line',
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'LineString'],
      ['!=', 'mode', 'static']
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': mapColors.routeColor,
      'line-width': 4
    }
  },
  // LINE ACTIVE
  {
    id: 'gl-draw-line-active',
    type: 'line',
    filter: ['all', ['==', '$type', 'LineString'], ['==', 'active', 'true']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': mapColors.activeColor,
      // 'line-dasharray': [0.2, 2],
      'line-width': 4
    }
  },
  // FILL STROKE AND LINE VERTEX INACTIVE
  {
    id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
    type: 'circle',
    filter: [
      'all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static']
    ],
    paint: {
      'circle-radius': 5,
      'circle-color': mapColors.activeColor,
      'circle-pitch-alignment': 'map'
    }
  },
  // FILL STROKE AND LINE VERTEX INACTIVE
  {
    id: 'gl-draw-polygon-and-line-vertex-inactive',
    type: 'circle',
    filter: [
      'all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static']
    ],
    paint: {
      'circle-radius': 5,
      'circle-color': mapColors.activeColor,
      'circle-pitch-alignment': 'map'
    }
  },
  // --- POINT ---
  // POINT STROKE INACTIVE
  {
    id: 'gl-draw-point-point-stroke-inactive',
    type: 'circle',
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
      ['!=', 'mode', 'static']
    ],
    paint: {
      'circle-radius': 6,
      'circle-opacity': 1,
      'circle-color': mapColors.routeColor,
      'circle-pitch-alignment': 'map'
    }
  },
  // POINT FILL INACTIVE
  {
    id: 'gl-draw-point-inactive',
    type: 'circle',
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
      ['!=', 'mode', 'static']
    ],
    paint: {
      'circle-radius': 4,
      'circle-color': mapColors.white,
      'circle-pitch-alignment': 'map'
    }
  },
  // POINT STROKE ACTIVE
  {
    id: 'gl-draw-point-stroke-active',
    type: 'circle',
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['==', 'active', 'true'],
      ['!=', 'meta', 'midpoint']
    ],
    paint: {
      'circle-radius': 12,
      'circle-color': mapColors.activeColor,
      'circle-pitch-alignment': 'map'
    }
  },
  // POINT FILL ACTIVE
  {
    id: 'gl-draw-point-active',
    type: 'circle',
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['!=', 'meta', 'midpoint'],
      ['==', 'active', 'true']
    ],
    paint: {
      'circle-radius': 8,
      'circle-color': mapColors.white,
      'circle-pitch-alignment': 'map'
    }
  }
]
